export default __webpack_public_path__ + "static/FTRegolaNeue-Semibold-eccddf3186b667b65bbccb52165a65b0.woff";